import { render, staticRenderFns } from "./PageSupport.vue?vue&type=template&id=548e3cbc&scoped=true"
import script from "./PageSupport.vue?vue&type=script&lang=ts"
export * from "./PageSupport.vue?vue&type=script&lang=ts"
import style0 from "./PageSupport.vue?vue&type=style&index=0&id=548e3cbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548e3cbc",
  null
  
)

export default component.exports